import axios from 'axios';

export const API_BASE_URL = (process.env.REACT_APP_IMAGE_URL || '').replace(/\/$/, '');

/**
 * Resolves a service image URL.
 * Backend stores images as relative paths like "/uploads/filename.jpg".
 * This converts them to absolute URLs pointing to the backend server.
 */
export const resolveImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    if (typeof imageUrl !== 'string') return null;
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) return imageUrl;
    return `${String(API_BASE_URL || '').replace(/\/$/, '')}/${imageUrl.replace(/^\/+/, '')}`;
};

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || `${API_BASE_URL}/api`,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Interceptor to add Authorization JWT token
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('1App_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor to handle common responses (unauthorized, etc)
API.interceptors.response.use(
    (response) => response,
    (error) => {
        const requestToken = error.config?.headers?.Authorization;
        const currentToken = localStorage.getItem('1App_token');
        if (error.response?.status === 401 && currentToken && requestToken === `Bearer ${currentToken}`) {
            localStorage.removeItem('1App_token');
            localStorage.removeItem('1App_refreshToken');
            window.dispatchEvent(new Event('1App:session-expired'));
        }
        return Promise.reject(error);
    }
);

export default API;

export const chatApi = {
    getUnreadCount: (participantType, participantId) => API.get(`/chat/conversations/${participantType}/${participantId}/unread-count`),
    getMessages: (technicianId, params = {}) => API.get(`/chat/conversations/${technicianId}/messages`, { params }),
    markRead: (technicianId) => API.patch(`/chat/conversations/${technicianId}/read`),
    sendMedia: (technicianId, formData) => API.post(`/chat/conversations/${technicianId}/messages`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    getUserMessages: (userId, params = {}) => API.get(`/chat/conversations/user/${userId}/messages`, { params }),
    markUserRead: userId => API.patch(`/chat/conversations/user/${userId}/read`),
    sendUserMedia: (userId, formData) => API.post(`/chat/conversations/user/${userId}/messages`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};
